import useAutoPlay from './use-auto-play';

type VideoProps = JSX.IntrinsicElements['video'];

interface AutoPlayVideoProps extends VideoProps {
  src: string;
  poster: string;
}

const AutoPlayVideo = ({ src, muted = true, playsInline = true, className, ...props }: AutoPlayVideoProps) => {
  const { ref: videoRef } = useAutoPlay({ autoPlay: true, src });

  return (
    <video
      src={src}
      muted={muted}
      preload="auto"
      playsInline={playsInline}
      webkit-playsinline={playsInline ? 'true' : 'false'}
      x5-playsinline={playsInline ? 'true' : 'false'}
      disablePictureInPicture
      className={className}
      ref={videoRef}
      {...props}
    />
  );
};

export default AutoPlayVideo;
